import { ENV } from '@/app/common/constants'
import { parseRequestError } from '@/app/common/utilities'
import { MarketplaceStoreSchema } from '@/queries/marketplace/schema'
import axios from 'axios'
import { MarketplaceItemListSchema } from '../marketplace/marketplace.schema'
import { MarketplacePreviewItemsParams } from './hooks/useMarketplacePreviewItems'

export type MarketplacePreviewStoresParams = {
  perPage: number
  page: number
  search: string
  business_type: string
}

export const marketplacePreviewAxiosInstance = axios.create({
  baseURL: ENV.VITE_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  params: {
    global_on_id: ENV.VITE_WALLET_GLOBAL_ON_ID,
  },
})

export const GETMarketplacePreviewItems = async (
  params: MarketplacePreviewItemsParams
) => {
  try {
    const response = await marketplacePreviewAxiosInstance.get(
      '/preview/marketplace_preview/items',
      {
        params: {
          per_page: params.perPage,
          page: params.page,
          search: params.search,
        },
      }
    )

    return MarketplaceItemListSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const GETMarketplacePreviewStores = async (
  params: MarketplacePreviewStoresParams
) => {
  try {
    const response = await marketplacePreviewAxiosInstance.get(
      `/preview/marketplace_preview/stores`,
      {
        params: {
          per_page: params.perPage,
          page: params.page,
          search: params.search,
          business_type: params.business_type,
        },
      }
    )

    console.log(MarketplaceStoreSchema.safeParse(response.data).error?.message)
    return MarketplaceStoreSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}
